import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { AccountFilterData } from '@juvare/contact-management/ui/features/accounts/hooks/useAccountList';
import { useFeatureFlags } from '@juvare/credentialing/ui/hooks';
import { useTranslation } from 'react-i18next';
import { useAccountTableDataLists } from '../../../../../hooks/useAccountTableDataLists';
import { useEnvironmentConfig } from '../../../../../hooks/useEnvironmentConfig';

export function useExtendedHanAccountFilters() {
    const { t } = useTranslation();
    const { data: environmentConfig, error: environmentConfigError } = useEnvironmentConfig();
    const { stateCounties } = useAccountTableDataLists(environmentConfig?.stateCode);
    const { tribe: tribeEnabled } = useFeatureFlags();
    const extendedHanFilters = (builder: FilterConfigBuilder<AccountFilterData>) => {
        builder.allFiltersPanel({
            label: t('panels.accounts.filterLabels.hanRoles'),
            children: [
                builder.allFiltersWidget({
                    type: 'form.multiSelect',
                    key: 'hanRoles',
                    valueProvider: { type: 'classifier.hanRoles' },
                }),
            ],
        });

        if (!tribeEnabled) {
            builder.allFiltersPanel({
                label: t('panels.accounts.filterLabels.county'),
                children: [
                    builder.allFiltersWidget({
                        key: 'stateAndCounty',
                        type: 'form.multiSelect',
                        values:
                            stateCounties?.map((sc) => ({
                                value: `${environmentConfig?.stateCode} - ${sc.value}`,
                                label: sc.value,
                            })) ?? [],
                    }),
                    builder.allFiltersWidget({
                        key: 'outsideState',
                        type: 'form.checkbox',
                        label: t('panels.accounts.filterLabels.outsideState'),
                    }),
                ],
            });
        }
    };
    return { extendedHanFilters, environmentConfigError };
}
